import $ from 'jquery';
import atmosphere from 'atmosphere.js';

// const socket = atmosphere;

const websocketEvent = {};
const $wsEvent = $(websocketEvent);

function isLocal(){
    var url = window.location.href;
    var arr = url.split("/");
    var urlDomain = arr[2];
    return urlDomain.search("local") >= 0;
}


function makeRequest(path) {
	if (path.length === 0) {
		throw new Error('Can\'t connect with empty path');
	}

	const pathRegexp = /[^-_\w/]/;
	if (pathRegexp.test(path)) {
		throw new Error(`Only ${pathRegexp} in path please!`);
	}

    if (isLocal()){
        return;
    }

	const request = {
		url: `/websocket/connect/${path}`,
		transport: 'websocket',
		fallbackTransport: 'long-polling',
		contentType: 'application/json'
	};

	request.onOpen = response => {
		console.info('websocket-event-esm:Websocket connected using transport:', response.transport);
	};

	request.onMessage = response => {
		const message = response.responseBody;

		let json = {};
		try {
			json = $.parseJSON(message);
		} catch (e) {
			console.warn('That wasn\'t valid JSON:', message, e.message);
		}
		for (const name in json) {
			if (json.hasOwnProperty(name)) {
				$wsEvent.triggerHandler(name, json[name]);
			}
		}
	};

	request.onError = response => {
		console.warn('Websocket error:', response);
	};

	return request;
}

function on() {
	$wsEvent.on.apply($wsEvent, arguments);
}

function off() {
	$wsEvent.off.apply($wsEvent, arguments);
}

function connect() {
	disconnect();
	const path = Array.prototype.slice.call(arguments).join('/');
	websocketEvent.request = makeRequest(path);
    if (websocketEvent.request) {
        atmosphere.subscribe(websocketEvent.request);
    }
}

function disconnect() {
	if (websocketEvent.request) {
		atmosphere.unsubscribe(websocketEvent.request);
	}
}

websocketEvent.on = on;
websocketEvent.off = off;
websocketEvent.connect = connect;
websocketEvent.disconnect = disconnect;

export default websocketEvent;



// WEBPACK FOOTER //
// ./mobile-core/src/websocket/websocket-event-esm.js